import React from "react";

const Code = ({ children }) => {
  return (
    <span className="px-2 text-gray-800 bg-gray-200 rounded text-md">
      {children}
    </span>
  );
};

export default Code;
